import React, { useEffect, useRef, useState } from 'react'
import { SELECTED_STORAGE_KEYS } from '../../../../auth/core/constant'
import { usePaymentSchemesDash } from './PaymentSchemesDashboard'
import PaymentSchemesFilterComp from './PaymentSchemesFilterComp'
import { KTCard, KTCardBody, KTIcon } from '../../../../../../general/helpers'
import ListLoading from '../../components/loading/ListLoading'
import { PageTitle } from '../../../../../../general/layout/core'
import Pagination from '../../../components/Pagination'
import { useIntl } from 'react-intl'
import { PaymentSchemesTable } from './table/PaymentSchemesTable'
import { showToast } from '../../../core/helper'
import { usePaymentSchemesQueryRequest, PaymentSchemesQueryRequestProvider } from './core/PaymentSchemesRequestProvider'
import { usePaymentSchemesQueryResponse, PaymentSchemesQueryResponseProvider, usePaymentSchemesQueryResponseData, usePaymentSchemesQueryResponseTotalCount, usePaymentSchemesQueryResponseLoading } from './core/PaymentSchemesResponseProvider'
import { useAuth } from '../../../../auth'
import { PERMISSION_ARRKEY } from '../../../../auth/core/constant'
import { export_payment_schemes } from '../../../core/_request'
import { toast } from 'react-toastify'


function PaymentSchemesDashboardLayoutInner() {
    const [filterQueryStr, setFilterQueryStr] = useState<string>('')
    const [exportLoading, setExportLoading] = useState(false)

    const { isLoading, query } = usePaymentSchemesQueryResponse()
    const { state, updateState, loading } = usePaymentSchemesQueryRequest()
    const totalItems = usePaymentSchemesQueryResponseTotalCount()
    const queryListings = usePaymentSchemesQueryResponseData()
    const { getAllowedPermissionValue } = useAuth()

    const refTransactionsList = useRef(null)
    const intl = useIntl()

    const prevLoading = useRef(isLoading);

    useEffect(() => {
        sessionStorage.removeItem(SELECTED_STORAGE_KEYS.PAYMENT_SCHEMES_FILTERS_KEY)
    }, [])

    useEffect(() => {
        if (prevLoading.current && !isLoading && queryListings?.length === 0) {
            toast.error(
                showToast(
                    intl.formatMessage({
                        id: 'TRANSACTION.EMPTY',
                    })
                )
            )
        }
        prevLoading.current = isLoading
    }, [isLoading, queryListings, intl])


    const triggerPaymentSchemesExport = async () => {
        setExportLoading(true)
        try {
            await export_payment_schemes(query.replace('?', ''), {})
        } catch (e) {
            console.error(e)
        } finally {
            setExportLoading(false)
        }
    }

    return (
        <>
            <PageTitle>Payment Schemes</PageTitle>
            <KTCard>
                <KTCardBody className='pt-2'>
                    <PaymentSchemesFilterComp />
                </KTCardBody>
                <div ref={refTransactionsList} />
            </KTCard>

            {queryListings?.length > 0 && (
                <KTCard className='mt-5'>
                    <KTCardBody className='py-4'>
                        <div className='d-flex justify-content-end mb-4'>
                            {getAllowedPermissionValue(PERMISSION_ARRKEY.EXPORT_PAYMENTS) && (
                                <button
                                    disabled={exportLoading}
                                    type='button'
                                    className='btn btn-light-primary'
                                    onClick={triggerPaymentSchemesExport}
                                >
                                    {!exportLoading && <KTIcon iconName='exit-up' className='fs-2' />}
                                    {intl.formatMessage({ id: 'EXPORT' })}
                                    {exportLoading && (
                                        <span className='spinner-border spinner-border-sm align-middle text-primary ms-2' />
                                    )}
                                </button>
                            )}
                        </div>
                        {loading ? (
                            <ListLoading />
                        ) : (
                            <>
                                <PaymentSchemesTable />
                                <Pagination
                                    totalItems={totalItems}
                                    state={state}
                                    updateState={updateState}
                                />
                                {isLoading ? <ListLoading /> : <></>}
                            </>
                        )}
                    </KTCardBody>
                </KTCard>
            )}
        </>
    )
}

const PaymentSchemesDashboardLayout = () => (
    <PaymentSchemesQueryRequestProvider>
        <PaymentSchemesQueryResponseProvider>
            <PaymentSchemesDashboardLayoutInner />
        </PaymentSchemesQueryResponseProvider>
    </PaymentSchemesQueryRequestProvider>
)

export default PaymentSchemesDashboardLayout
